export const MSG_SENDER = '0x0000000000000000000000000000000000000001'
export const ADDRESS_THIS = '0x0000000000000000000000000000000000000002'

// = 1 << 23 or 100000000000000000000000
export const V1_FEE_PATH_PLACEHOLDER = 1
export const V2_FEE_PATH_PLACEHOLDER = 2
